import { html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import { dispatchCustomEvent } from '../../../base/package/util/event';
import { UIModal } from '../../ui-modal/ui-modal';
import style from './ui-generic-error-modal.css?inline';

const CName = 'generic-error-modal';

@customElement(CName)
export class UIGenericErrorModal extends UIModalServiceModal {
  static readonly styles = unsafeCSS(style);

  public close() {
    this._modalRef.value?.close();
  }

  render() {
    return html`
      <ui-modal
        ${ref(this._modalRef)}
        .onClosedAction=${() => {
          // TODO: doublecheck why this event is needed to be fired
          dispatchCustomEvent(this, UIModal.CLOSE_EVENT, { bubbles: true });
        }}
        .onAltAction=${(e: UIModal) => {
          e.close();
        }}
        .altActionButtonLabel=${window.$app.$t.get(I18n.base.ok)}
        class="modal--centered"
      >
        <div slot="title">
          <div class="icon">${this._createUIAttentionIcon()}</div>
          ${window.$app.$t.get(I18n.errors.generic.title)}
        </div>
        <div class="content" slot="main">
          <div>${window.$app.$t.get(I18n.errors.generic.text)}</div>
        </div>
      </ui-modal>
    `;
  }

  private _createUIAttentionIcon() {
    const name = 'error';
    return html`<ui-attention-icon .name=${name} class="size-xl"></ui-attention-icon>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIGenericErrorModal;
  }
}
